<template>
  <div class="data-content-pair" :style="{ color: textColor }">
    <div class="data-value">
      <div v-html="convertDirection(index)" />
      <!-- <div v-if="status" class="red-circle" />
      <div v-else class="green-circle" /> -->
    </div>
    <div class="data-value">{{ $t('transmitter') }}({{ index * 2 - 1 }}) : {{ sendValue }} - {{ unixtimeToLocaltime(sendUnixtime) }}</div>
    <div class="data-value">{{ $t('receiver') }}({{ index * 2 }}) : {{ recvValue }} - {{ unixtimeToLocaltime(recvUnixtime) }}</div>
    <div class="data-value" v-if="getPermission() < 4">
      <button type="button" class="restart-btn" @click="restartCmd(index)">{{ $t('restart') }}</button>
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import Swal from 'sweetalert2';
import {
  ref, computed, inject, onMounted,
} from 'vue';
import { $mqtt } from 'vue-paho-mqtt';
import { checkPages } from '../utils/stringValid';
import { getPermission } from '../../User';

export default {
  props: {
    index: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const apiBaseUrl = inject('apiBaseUrl');
    const url = 'project';
    const sendValue = ref(0);
    const recvValue = ref(0);
    const sendUnixtime = ref(0);
    const recvUnixtime = ref(0);
    const status = computed(() => {
      // const difference = Math.abs(sendValue.value - recvValue.value);
      const difference = Math.abs(sendUnixtime.value - recvUnixtime.value);
      return difference > 10;
    });
    const textColor = computed(() => {
      // const difference = Math.abs(sendValue.value - recvValue.value);
      const difference = Math.abs(sendUnixtime.value - recvUnixtime.value);
      return difference > 10 ? 'red' : 'black';
    });
    onMounted(() => {
      if (props.item.mac > 0 && props.item.topic) {
        const topic = props.item.topic.replace('{MAC}', `${props.item.mac}`);
        const topic2 = topic.replace('data', 'unixtime');
        const { index } = props;
        // console.log(topic2);
        $mqtt.subscribe(
          `${topic}/${index * 2 - 1}`,
          (message) => {
            sendValue.value = parseInt(message, 10);
          },
          false,
        );
        $mqtt.subscribe(
          `${topic}/${index * 2}`,
          (message) => {
            recvValue.value = parseInt(message, 10);
          },
          false,
        );
        $mqtt.subscribe(
          `${topic2}/${index * 2 - 1}`,
          (message) => {
            sendUnixtime.value = parseInt(message, 10);
          },
          false,
        );
        $mqtt.subscribe(
          `${topic2}/${index * 2}`,
          (message) => {
            recvUnixtime.value = parseInt(message, 10);
          },
          false,
        );
      }
    });
    return {
      t,
      apiBaseUrl,
      url,
      sendValue,
      recvValue,
      textColor,
      status,
      sendUnixtime,
      recvUnixtime,
    };
  },
  methods: {
    getPermission,
    checkPages,
    restartCmd() {
      let topic = this.item.topic.replace('{MAC}', `${this.item.mac}`);
      topic = topic.replace('data', 'cmd');
      const index = (this.index - 1) * 2;
      Swal.fire({
        icon: 'question',
        title: `${this.t('confirmRestart')}(${index + 1})&(${index + 2})?`,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
      }).then((result) => {
        if (result.isConfirmed) {
          let cmd = this.setBit(0, index, true);
          cmd = this.setBit(cmd, index + 1, true);
          $mqtt.publish(topic, `${cmd}`, 'B', false);
        }
      });
    },
    setBit(value, index, onoff) {
      let n = value;
      if (onoff === true) {
        // eslint-disable-next-line no-bitwise
        n |= 1 << index;
      } else {
        // eslint-disable-next-line no-bitwise
        n &= ~(1 << index);
      }
      return n;
    },
    unixtimeToLocaltime(unixTime) {
      if (unixTime === 0) return 'None';
      const date = new Date(unixTime * 1000);
      return date.toLocaleString('zh-TW', { timeZone: 'Asia/Taipei' });
    },
    convertDirection(index) {
      switch (index) {
        case 1:
          return '東';
        case 2:
          return '南';
        case 3:
          return '西';
        case 4:
          return '北';
        default:
          break;
      }
      return '';
    },
  },
};
</script>

<style>
.data-value {
  width: auto;
  padding-right: 5px;
}
.data-content-pair {
  display: grid;
  grid-template-columns: 0.01fr 1fr 1fr 0.1fr;
  column-gap: 0px;
  grid-auto-rows: minmax(min-content, max-content);
  border: 1px solid #ccc;
  border-radius: 3px;
  padding-left: 5px;
}
.restart-btn {
  width: 100%;
}
.red-circle {
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%;
  margin-top: 8px;
}
.green-circle {
  width: 10px;
  height: 10px;
  background-color: rgb(71, 255, 71);
  border-radius: 50%;
  margin-top: 8px;
}
@media (max-width: 600px) {
  .data-item {
    flex-direction: column;
    align-items: start;
  }
}
</style>
